'use strict';

var vkBeautify = require('vkbeautify');
var SystemStatusFlightSentRequestDirective = function SystemStatusFlightSentRequestDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-flight-sent-request.html'),
    link: function link($scope) {
      $scope.$on('statusMessage:show', function () {
        $scope.requestParsedContent = vkBeautify.xml($scope.modalData.sentStatusContent || '', 2);
        if ($scope.modalData.sentStatus) {
          $scope.requestStatus = 'SENT';
        }
      });
    }
  };
};
SystemStatusFlightSentRequestDirective.$inject = [];
module.exports = SystemStatusFlightSentRequestDirective;